import React, { useRef } from 'react';
import useDropdown from '@/_hooks/useDropdown';

export const Tooltip = ({ children, optionsButton, onClick }) => {
    const tooltipElm = useRef(null);
    const openTooltipElm = useRef(null);
    const [tooltip, toggle] = useDropdown(openTooltipElm, tooltipElm);

    function handleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) onClick(e);
        toggle();
    }

    return (
        <span>
            <div ref={tooltipElm} onClick={handleClick}>
                {optionsButton}
            </div>
            {tooltip && (
                <div className="tooltip-options-box" ref={openTooltipElm} onClick={e => e.stopPropagation()}>
                    {typeof children === 'function' ? children(toggle) : children}
                </div>
            )}
        </span>
    );
};

export default Tooltip;
